// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.st0[data-v-82b9a582] {\n\tfill: #FFFFFF;\n}\n", ""]);
// Exports
module.exports = exports;
